import { RootLayout } from './RootLayout';
import { StorefrontHeaderActions } from '@/features/storefront/components/StorefrontHeaderActions';
import { StorefrontMobileActions } from '@/features/storefront/components/StorefrontMobileActions';
import { StorefrontSearchAutocomplete } from '@/features/storefront/components/StorefrontSearchAutocomplete';

/**
 * `RootLayout` do ramo autenticado: mesmo casco, mais as ações que só existem
 * com sessão.
 *
 * Componente próprio em vez de `element={<RootLayout rightSlot={...} />}` no
 * router para manter o `router.tsx` legível e o import do slot fora do módulo
 * que a rota pública também carrega.
 */
export function ProtectedLayout() {
  return (
    <RootLayout
      searchSlot={<StorefrontSearchAutocomplete />}
      rightSlot={<StorefrontHeaderActions />}
      mobileSlot={<StorefrontMobileActions />}
    />
  );
}
